import Subject from "../cse4sub/Subject";
import React from 'react'
import cse from '../assets/CSEASH207end21.pdf'

export default function CLab() {
  return (
    <div>
       <Subject title="Programming for Problem Solving Lab(ASH207)" 
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21="#" end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}